import script from "./ModalPointHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalPointHistory.vue?vue&type=script&lang=ts&setup=true"

import "./ModalPointHistory.vue?vue&type=style&index=0&id=45d49a81&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d49a81"]])

export default __exports__